import '../menu.css';
import Check from './check';
import Connect from './connect';
import dataStore from '../../data/data';
import Join from '../session/join';
import RTCPeer from './audio/rtc-peer';
import SocketManager from './socket/manager';
import StreamAudio from './audio/stream-audio';
import {castPeer,castVitruvian} from '../mediaprocessing/cast/cast';
import {StreamAudioMedia,StreamLandmarkMedia} from '../mediaprocessing/stream/stream';
import {useEffect,useRef} from 'react';

const Propagate = () => {
  const audioRef = useRef(null);
  const camera = dataStore(_data => _data.mirror.camera);
  const canvasRef = useRef(null);
  const cleanupRef = useRef(null);
  const data=dataStore((_data)=>_data);
  const startedRef=useRef(false);
  const streamRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    if (!videoRef.current) return;
  },[videoRef]);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current=true;
    if (!camera || !videoRef.current) return;

    const run = async () => {
      try{
        const setData = dataStore.setState;
  
        const currentDate = new Date().toLocaleDateString('en-US', {
          timeZone: 'UTC',
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
        }).replace(/\//g, '-');
  
        setData((_data) => ({
          ..._data,
          mirror: {
            ..._data.mirror,
            currentDate,
          },
        }));
  
        const checks = await Check();
        const check = checks.every(c => c.ok);
  
        if (!check) {
          console.log('check failed', checks);
          return;
        } else {
          console.log('check passed');
          const WS_URL = `${process.env.REACT_APP_PHI_WEB_SOCKET_URL}/${process.env.REACT_APP_STAGING}`;
          const socket = new WebSocket(WS_URL);
          const rtcPeer = RTCPeer();
  
          await Join();
          await Connect(socket);
          SocketManager(rtcPeer,socket);
  
          try {
            await StreamLandmarkMedia(canvasRef, cleanupRef, streamRef, videoRef);
            const audioMedia=await StreamAudioMedia(audioRef);
            await StreamAudio({localStream:audioMedia,rtcPeer,socket});
          } catch (err) {
            console.error('stream failed: ', err);
          }
        }
      } catch (err) {
        startedRef.current=false;
        throw err;
      }
    };

    run();
  }, [camera]);

  useEffect(() => {castVitruvian();}, [data.mediaprocessing.vitruvian.face.cast.landmarks.live]);
  useEffect(() => {castPeer();}, [data.mediaprocessing.peer.face.cast.landmarks.live]);

  return (
    <div style={{ position: 'relative' }}>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        style={{ width: '100%', borderRadius: '8px' }}
      />
      <canvas
        ref={canvasRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none'
        }}
      />
    </div>
  );
};

export default Propagate;